import React, { useState, useEffect } from "react";

// External Package
import { useSelector } from "react-redux";

// State
import { RootState } from "../../store/authStore";

// Source
import { packagesData } from "../../source/servicePackagesSource";
export default function ServicePackagesComponents() {
  // variable
  const isMobile = useSelector((state: RootState) => state.auth.isMobile);
  const [features, setFeatures] = useState<
    { describe: string; active: boolean; value: string }[]
  >([]);
  const [selectedPackage, setSelectedPackage] = useState<string>("");

  // function
  const handleDetailClick = (label: string) => {
    const data = packagesData.filter((item) => item.label === label);
    setSelectedPackage(data[0].label);
    setFeatures(data[0].features);
  };

  const handleOrderClick = () => {
    const message = `Halo Bale's!%0APerkenalkan saya .... .%0AIngin bertanya mengenai jasa pembuatan website dengan paket ${selectedPackage}.%0A%0AFormat Pemesanan:%0ANama: ......%0APaket: ${selectedPackage}%0AEmail: ...... %0ANo HP / WhatsApp: ..... %0ALanding Page / Company Profile: .....`;
    const url = `https://wa.me/6281216593329?text=${message}`;
    window.open(url, "_blank");
  };

  const handleOrderCustomClick = () => {
    const message = `Halo Bale's!%0APerkenalkan saya .... .%0AIngin bertanya mengenai jasa pembuatan website dengan custom website.%0A%0AFormat Pemesanan:%0ANama: ...... %0AEmail: ...... %0ANo HP / WhatsApp: ..... %Custome Website: .....`;
    const url = `https://wa.me/6281216593329?text=${message}`;
    window.open(url, "_blank");
  };

  // useEffect to set default value
  useEffect(() => {
    const defaultPackage = packagesData.find((item) => item.label === "Gold");
    if (defaultPackage) {
      setSelectedPackage(defaultPackage.label);
      setFeatures(defaultPackage.features);
    }
  }, []);

  return (
    <div className="services_content_packages mt-5">
      <div className="header">
        <h2 className="font-vietnam-600">Best package</h2>
        <label htmlFor="" className="font-vietnam-200-italic">
          Temukan paket terbaik kami yang dirancang khusus untuk memenuhi
          kebutuhan bisnis Anda. Dengan harga yang kompetitif dan layanan
          berkualitas tinggi, kami siap membantu Anda mencapai kesuksesan.
          Jangan lewatkan kesempatan untuk mendapatkan solusi terbaik dengan
          nilai luar biasa!
        </label>
      </div>
      {isMobile ? (
        <div className="content mt-5">
          <div className="row">
            <div className="col-12 mb-5">
              <div className="content_packages">
                <div className="row">
                  {packagesData.map((item) => (
                    <div className="col-12 mb-4" key={item.id}>
                      <div
                        className={`packages p-4 d-flex flex-column text-center ${
                          item.label === selectedPackage
                            ? "active-packages"
                            : ""
                        }`}
                      >
                        <label
                          htmlFor={item.label}
                          className="title font-size-28 font-vietnam-600"
                        >
                          {item.label}
                        </label>
                        <div className="price mt-2">
                          <label
                            htmlFor=""
                            className="font-size-36 d-flex justify-content-center"
                          >
                            <span className="font-size-14">IDR</span>
                            {item.price}
                          </label>
                          <div className="years mt-1 font-vietnam-200-italic">
                            {item.duration}
                          </div>
                        </div>
                        <button
                          className="btn btn-detail-outline rounded-0 mt-2"
                          onClick={() => handleDetailClick(item.label)}
                        >
                          Detail
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="content_packages_custom">
                  <div className="row">
                    <div className="col-12">
                      <div className="packages_custom">
                        <label
                          htmlFor=""
                          className="title font-size-28 font-vietnam-600"
                        >
                          Custom Website
                        </label>
                        <p className="font-size-18 font-vietnam-200-italic">
                          Ingin website yang benar-benar sesuai dengan kebutuhan
                          bisnis Anda? Kami menawarkan layanan pembuatan website
                          custom yang dapat didiskusikan sesuai keinginan Anda.
                          Dapatkan solusi yang tepat dan unik untuk bisnis Anda
                          dengan berdiskusi bersama tim ahli kami!
                        </p>
                      </div>
                      <button
                        className="btn btn-detail rounded-0 mt-2 w-100"
                        onClick={handleOrderCustomClick}
                      >
                        Diskusi Dengan Kami
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 mt-5">
              <div className="content_detail_packages mb-4">
                <div className="title font-size-36 font-vietnam-600">
                  {" "}
                  Package {selectedPackage}{" "}
                </div>
                <div className="content">
                  {features.map((feature, index) => (
                    <div className="row" key={index}>
                      <div className="col-6 describe font-size-18 font-vietnam-600">
                        {feature.describe}
                      </div>
                      <div className="col-6 value text-center">
                        {feature.active && feature.value !== "approved" ? (
                          feature.value
                        ) : (
                          <img
                            src={require("../../assets/icons/approve.png")}
                            alt="services"
                            width={30}
                            height={30}
                            loading="lazy"
                          />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="row">
                  <div className="col-12">
                    <button
                      className="btn btn-detail w-100 rounded-0 mt-2"
                      onClick={handleOrderClick}
                    >
                      Pesan Sekarang!
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="content mt-5">
          <div className="row">
            <div className="col-5">
              <div className="content_detail_packages">
                <div className="title font-size-36 font-vietnam-600">
                  {" "}
                  Package {selectedPackage}{" "}
                </div>
                <div className="content">
                  {features.map((feature, index) => (
                    <div className="row" key={index}>
                      <div className="col-6 describe font-size-18 font-vietnam-600">
                        {feature.describe}
                      </div>
                      <div className="col-6 value text-center">
                        {feature.active && feature.value !== "approved" ? (
                          feature.value
                        ) : (
                          <img
                            src={require("../../assets/icons/approve.png")}
                            alt="services"
                            width={30}
                            height={30}
                            loading="lazy"
                          />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="row">
                  <div className="col-12">
                    <button
                      className="btn btn-detail w-100 rounded-0 mt-2"
                      onClick={handleOrderClick}
                    >
                      Pesan Sekarang!
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-7">
              <div className="content_packages">
                <div className="row">
                  {packagesData.map((item) => (
                    <div className="col-4" key={item.id}>
                      <div
                        className={`packages p-4 d-flex flex-column text-center ${
                          item.label === selectedPackage
                            ? "active-packages"
                            : ""
                        }`}
                      >
                        <label
                          htmlFor={item.label}
                          className="title font-size-28 font-vietnam-600"
                        >
                          {item.label}
                        </label>
                        <div className="price mt-2">
                          <label
                            htmlFor=""
                            className="font-size-36 d-flex justify-content-center"
                          >
                            <span className="font-size-14">IDR</span>
                            {item.price}
                          </label>
                          <div className="years mt-1 font-vietnam-200-italic">
                            {item.duration}
                          </div>
                        </div>
                        <button
                          className="btn btn-detail-outline rounded-0 mt-2"
                          onClick={() => handleDetailClick(item.label)}
                        >
                          Detail
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="content_packages_custom">
                  <div className="row">
                    <div className="col-12">
                      <div className="packages_custom">
                        <label
                          htmlFor=""
                          className="title font-size-28 font-vietnam-600"
                        >
                          Custom Website
                        </label>
                        <p className="font-size-18 font-vietnam-200-italic">
                          Ingin website yang benar-benar sesuai dengan kebutuhan
                          bisnis Anda? Kami menawarkan layanan pembuatan website
                          custom yang dapat didiskusikan sesuai keinginan Anda.
                          Dapatkan solusi yang tepat dan unik untuk bisnis Anda
                          dengan berdiskusi bersama tim ahli kami!
                        </p>
                        <button
                          className="btn btn-detail rounded-0 mt-2"
                          onClick={handleOrderCustomClick}
                        >
                          Diskusi Dengan Kami
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
